// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"441":"modals-publish","454":"drawing-creators","550":"portfolio-watchlist","882":"chart-settings"}[chunkId] || chunkId) + "." + {"327":"ff13f220","441":"d1c3a689","454":"0110a2fd","550":"352129f3","882":"5d36bf00"}[chunkId] + ".js";
};